/*
 * File: catalog-action-menu.component.ts                                      *
 * Project: catalog-cloud                                                      *
 * File Created: Wednesday, 22nd December 2021 12:48:17                        *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 11th March 2022 16:31:19                             *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */




import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogService } from '../../../services/catalog.service';
import { PageTemplateService } from '../../../services/page-template.service';

@Component({
  selector: 'app-catalog-action-menu',
  templateUrl: './catalog-action-menu.component.html',
  styleUrls: ['./catalog-action-menu.component.scss']
})
export class CatalogActionMenuComponent implements OnInit {

  buttons: any[] = [];


  constructor (private catalogService: CatalogService,
    private pageTemplateService: PageTemplateService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.setButtons();
  }

  setButtons() {
    this.buttons = [
      {
        label: 'CATALOG.CREATE',
        icon: 'pi pi-plus',
        severity: 'info',
        action: () => this.openCatalog()
      }

    ];
  }

  openCatalog() {
    this.router.navigate(['/catalog/new']);
  }

  openPageTemplatesList() {
    this.pageTemplateService.openTemplateList();
  }

}
